import { Typeform } from "@swizec/gatsby-theme-course-platform";
import * as React from 'react';
export default {
  Typeform,
  React
};